import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../../styles';
import { ColumnProps } from './../column';
import { ControlBarDropdown } from '../../../components/navigation';
import ColumnToggleSections from './column-sections';
import ColumnToggleList from './column-list';
import { SearchInput } from '../../../atoms/forms';
import { IconButton } from '../../../atoms/buttons';

export interface ColumnToggleProps {
  className?: string;
  visibleColumns: { [key: string]: boolean };
  columns: ColumnProps[];
  toggleColumn: (column: string) => void;
  toggleColumns: (columns: string[]) => void;
  label?: string;
  selectAllLabel?: string;
}

interface State {
  search: string;
}

class ColumnToggle extends React.Component<ColumnToggleProps, State> {
  state = {
    search: '',
  };

  selectAllCheckBoxState = () => {
    const { columns, visibleColumns } = this.props;
    return columns.every(({ dataKey }) => visibleColumns[dataKey]);
  };

  onSearchChange = ({ target }) => this.setState({ search: target.value });

  onSearchClear = ({ target }) => this.setState({ search: '' });

  render() {
    const { className, columns, label } = this.props;
    const { search } = this.state;

    const toggleableColumns = columns.filter(c => !c.alwaysVisible);
    const toggleableSections = [
      ...new Set(toggleableColumns.map(c => c.sectionName)),
    ];

    const filteredColumns = toggleableColumns.filter(c =>
      c.label
        .toString()
        .toLowerCase()
        .includes(search.toLowerCase()),
    );

    return (
      <div className={className}>
        <ControlBarDropdown
          className="toggle"
          icon="columns"
          color={colors.grey500}
          label={label}
        >
          <div className="search-wrap">
            <SearchInput
              id="toggle-columns-search"
              autoFocus={true}
              value={search}
              iconColor={colors.grey900}
              iconSize="md"
              onChange={this.onSearchChange}
            />
            {search && (
              <IconButton
                icon="closeCircle"
                className="clean-btn"
                baseColor={colors.grey900}
                onClick={this.onSearchClear}
              />
            )}
          </div>
          {search ? (
            <ColumnToggleList
              {...this.props}
              className="search-results"
              columns={filteredColumns}
            />
          ) : toggleableSections.length === 1 ? (
            <ColumnToggleList
              {...this.props}
              className="toggle-columns"
              columns={toggleableColumns}
            />
          ) : (
            <ColumnToggleSections
              {...this.props}
              className="toggle-sections"
              columns={toggleableColumns}
              sections={toggleableSections}
              checked={this.selectAllCheckBoxState()}
            />
          )}
        </ControlBarDropdown>
      </div>
    );
  }
}

export default styled(ColumnToggle)`
  z-index: 6;
  position: relative;

  .toggle {
    height: 3.125rem;
    display: flex;
    > div {
      display: flex;
    }
  }

  .drawer {
    flex-direction: column;
    box-shadow: 0 0 0 1px ${colors.grey150}, 0 4px 32px 0 rgba(0, 0, 0, 0.1);
    left: 0;
    top: 3.8rem;
    max-height: 80vh;
    min-width: 220px;
    overflow-x: hidden;
    overflow-y: auto;
    border-radius: 0.5rem;
  }

  .toggle-columns {
    border-top: 1px solid ${colors.grey150};
  }

  .search-results {
    background: ${colors.grey10};
    > div {
      border-top: 1px solid ${colors.grey150};
    }
  }

  .search-wrap {
    position: relative;

    .clean-btn {
      position: absolute;
      top: calc(50% - 10px);
      right: 10px;
    }

    label {
      cursor: pointer;
      left: 1rem;
      padding: 0.8rem 0;
    }

    input {
      box-shadow: none;
      padding: 1rem 0.5rem 1rem 3rem;
      ::placeholder {
        color: ${colors.grey700};
      }
    }
  }
`;
